<template>
  <div class="logo">
    <!-- <router-link :to="{name:'permission'}"> -->
    <!--<LogoSvg alt="logo" />-->
    <img :src="logo" width="80">
    <h1 v-if="showTitle">{{ title }}</h1>
    <!-- </router-link> -->
  </div>
</template>

<script>
// import LogoSvg from '@/assets/logo.svg?inline'
import logo from '@/assets/logo.png'

export default {
  name: 'Logo',
  components: {
    // LogoSvg
    // logo
  },
  props: {
    title: {
      type: String,
      default: '保险通用审核平台',
      required: false
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data() {
    return {
      logo: logo
    }
  }
}
</script>
